/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import { useTheme } from "@cd2/theme"
import { Grid } from "@cd2/components"
import { H1, P } from "@cd2/text"
import { PrimaryButton } from "../../components/Buttons"

export function PageNotFound() {
  const { sizes } = useTheme()

  return (
    <div
      css={css`
        display: flex;
        justify-content: center;
        text-align: center;
        height: calc(100vh - 500px);
      `}
    >
      <Grid
        alignItems="center"
        justifyItems="center"
        css={css`
          width: 100%;
        `}
      >
        <Grid gap={sizes.medium}>
          <H1 align="center">Page not found</H1>
          <P align="center">This page may have moved...</P>
          <div>
            <PrimaryButton to="/">Back to home</PrimaryButton>
          </div>
        </Grid>
      </Grid>
    </div>
  )
}
